// extracted by mini-css-extract-plugin
module.exports = {"shadowed":"Navbar_shadowed__3WL2c","navList":"Navbar_navList__RwM-9","logo":"Navbar_logo__3TDue","dark":"Navbar_dark__1Fw6d","topRow":"Navbar_topRow__3z73h"};